// Простой i18n для WebApp: RU/EN, автоопределение по региону (Telegram language_code
// -> navigator.language), переключение в Настройках, запоминание в localStorage.
import React, { createContext, useContext, useState, useCallback } from 'react';

export const LANGS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
];

export const DICT = {
  en: {
    'nav.swap': 'Swap', 'nav.trade': 'Trade', 'nav.wallet': 'Wallet',
    'common.back': 'Back', 'common.soon': 'Soon',
    'common.cancel': 'Cancel', 'common.save': 'Save', 'common.close': 'Close',
    'wallet.deposit': 'Deposit', 'wallet.withdraw': 'Withdraw', 'wallet.transfer': 'Transfer',
    'wallet.assets': 'Assets', 'wallet.manage': 'Manage', 'wallet.history': 'History',
    'bal.total': 'Total', 'bal.spot': 'Spot', 'bal.trade': 'Trade',
    'settings.open': 'Settings', 'settings.title': 'Settings',
    'settings.general': 'General', 'settings.tokens': 'Tokens',
    'settings.manageTokens': 'Manage tokens',
    'settings.manageTokensDesc': 'Choose which tokens appear in your wallet',
    'settings.language': 'Language', 'settings.languageDesc': 'Interface language',
    'manage.title': 'Manage tokens',
    'manage.hint': 'Toggle which tokens appear in Assets. USDT is always shown.',
    'manage.alwaysOn': 'always on', 'manage.hasBalance': 'has balance',
    'deposit.title': 'Deposit', 'withdraw.title': 'Withdraw', 'transfer.title': 'Transfer',
    'activity.title': 'Activity', 'activity.empty': 'No activity yet', 'activity.showMore': 'Show more',
    'tx.deposit': 'Deposit', 'tx.withdraw': 'Withdraw', 'tx.swap': 'Swap', 'tx.transfer': 'Transfer',
    'tx.status.pending': 'Pending', 'tx.status.completed': 'Completed',
    'settings.account': 'Account', 'settings.copyId': 'Tap to copy ID', 'common.copied': 'Copied',
    'settings.balances': 'Balances',
    'settings.hide': 'Hide', 'settings.hideDesc': 'What to hide in the wallet',
    'settings.hideBalance': 'Hide balance', 'settings.hideBalanceDesc': 'Mask all amounts',
    'settings.hideSmall': 'Hide small balances', 'settings.hideSmallDesc': 'Hide assets under $1',
    'settings.notifications': 'Notifications',
    'settings.notifDeposit': 'Deposit alerts', 'settings.notifDepositDesc': 'Notify when funds arrive',
    'settings.notifWithdraw': 'Withdrawal alerts', 'settings.notifWithdrawDesc': 'Notify on withdrawals',
    'settings.wallet': 'Wallet',
    'settings.region': 'Region', 'settings.timezone': 'Time zone', 'settings.timezoneDesc': 'Used for all times in the app', 'settings.recommended': 'Recommended',
    'settings.support': 'Support', 'settings.supportDesc': 'Contact us on Telegram', 'settings.supportTitle': 'Support',
  },
  ru: {
    'nav.swap': 'Обмен', 'nav.trade': 'Трейд', 'nav.wallet': 'Кошелёк',
    'common.back': 'Назад', 'common.soon': 'Скоро',
    'common.cancel': 'Отмена', 'common.save': 'Сохранить', 'common.close': 'Закрыть',
    'wallet.deposit': 'Пополнить', 'wallet.withdraw': 'Вывести', 'wallet.transfer': 'Перевод',
    'wallet.assets': 'Активы', 'wallet.manage': 'Токены', 'wallet.history': 'История',
    'bal.total': 'Всего', 'bal.spot': 'Спот', 'bal.trade': 'Трейд',
    'settings.open': 'Настройки', 'settings.title': 'Настройки',
    'settings.general': 'Общее', 'settings.tokens': 'Токены',
    'settings.manageTokens': 'Управление токенами',
    'settings.manageTokensDesc': 'Выберите, какие токены показывать в кошельке',
    'settings.language': 'Язык', 'settings.languageDesc': 'Язык интерфейса',
    'manage.title': 'Управление токенами',
    'manage.hint': 'Какие токены показывать в Активах. USDT всегда виден.',
    'manage.alwaysOn': 'всегда вкл', 'manage.hasBalance': 'есть баланс',
    'deposit.title': 'Пополнение', 'withdraw.title': 'Вывод', 'transfer.title': 'Перевод',
    'activity.title': 'История', 'activity.empty': 'Пока нет операций', 'activity.showMore': 'Показать ещё',
    'tx.deposit': 'Пополнение', 'tx.withdraw': 'Вывод', 'tx.swap': 'Обмен', 'tx.transfer': 'Перевод',
    'tx.status.pending': 'Ожидание', 'tx.status.completed': 'Выполнено',
    'settings.account': 'Аккаунт', 'settings.copyId': 'Нажми, чтобы скопировать ID', 'common.copied': 'Скопировано',
    'settings.balances': 'Балансы',
    'settings.hide': 'Скрытие', 'settings.hideDesc': 'Что скрывать в кошельке',
    'settings.hideBalance': 'Скрыть баланс', 'settings.hideBalanceDesc': 'Скрыть все суммы',
    'settings.hideSmall': 'Скрыть мелкие балансы', 'settings.hideSmallDesc': 'Прятать активы дешевле $1',
    'settings.notifications': 'Уведомления',
    'settings.notifDeposit': 'Уведомления о пополнениях', 'settings.notifDepositDesc': 'Сообщать о зачислениях',
    'settings.notifWithdraw': 'Уведомления о выводах', 'settings.notifWithdrawDesc': 'Сообщать о выводах',
    'settings.wallet': 'Кошелёк',
    'settings.region': 'Регион', 'settings.timezone': 'Часовой пояс', 'settings.timezoneDesc': 'Используется для времени во всём приложении', 'settings.recommended': 'рекомендуемо',
    'settings.support': 'Поддержка', 'settings.supportDesc': 'Связаться с нами в Telegram', 'settings.supportTitle': 'Поддержка',
  },
};

export function detectLang() {
  try {
    const saved = localStorage.getItem('lang');
    if (saved === 'ru' || saved === 'en') return saved;
  } catch (e) {}
  try {
    const tg = window.Telegram && window.Telegram.WebApp
      && window.Telegram.WebApp.initDataUnsafe
      && window.Telegram.WebApp.initDataUnsafe.user
      && window.Telegram.WebApp.initDataUnsafe.user.language_code;
    if (tg) return String(tg).toLowerCase().startsWith('ru') ? 'ru' : 'en';
  } catch (e) {}
  try {
    const n = (navigator.language || navigator.userLanguage || '').toLowerCase();
    if (n.startsWith('ru') || n.startsWith('uk') || n.startsWith('be') || n.startsWith('kk')) return 'ru';
  } catch (e) {}
  return 'en';
}

const LangContext = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);
  const setLang = useCallback((l) => {
    if (l !== 'ru' && l !== 'en') return;
    setLangState(l);
    try { localStorage.setItem('lang', l); } catch (e) {}
  }, []);
  const t = useCallback(
    (key) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key,
    [lang]
  );
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
